<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">投诉记录</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <div>
              <el-select v-model="listQuery.submit_type" filterable placeholder="内部报备/外部报备" style="margin-right: 20px">
                <el-option v-for="item in reportOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.game_id" filterable placeholder="游戏名称" style="margin-right: 20px">
                <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-input v-model="listQuery.account" placeholder="账号" style="width: 150px; margin-right: 20px"></el-input>
              <el-input v-model="listQuery.complaint_content" placeholder="问题详情" style="width: 150px; margin-right: 20px"></el-input>
              <el-select v-model="listQuery.complaint_type" filterable placeholder="投诉类型" style="margin-right: 20px">
                <el-option v-for="item in complaintTypeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.risk_type" filterable placeholder="风险类型" style="margin-right: 20px">
                <el-option v-for="item in riskTypeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.risk_level" filterable placeholder="风险等级" style="margin-right: 20px">
                <el-option v-for="item in riskLevelOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.complaint_level" filterable placeholder="严重程度" style="margin-right: 20px">
                <el-option v-for="item in complaintLevel" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.after_service" filterable placeholder="后续沟通" style="margin-right: 20px">
                <el-option v-for="item in afterService" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select filterable v-model="listQuery.is_ding_talk" placeholder="通知状态" style="margin-right: 15px">
                <el-option v-for="item in noticeStatusOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-select v-model="listQuery.upgrade_type" filterable placeholder="是否升级" style="margin-right: 20px; margin-top: 10px">
                <el-option v-for="item in checkUpgradeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-input v-model="listQuery.submit_admin" placeholder="提交人" style="width: 150px; margin-right: 20px"></el-input>
              <el-select v-model="listQuery.audit_status" filterable placeholder="审批状态" style="margin-right: 20px; margin-top: 10px">
                <el-option v-for="item in audit_statusOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-date-picker
                style="margin-right: 20px; margin-top: 10px"
                v-model="listQuery.created_at"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['24:00:00']"
              ></el-date-picker>
            </div>

            <div style="float: right; margin: 20px 30px 10px 0">
              <el-button type="primary" icon="el-icon-edit" @click="search" style="">搜索</el-button>
              <el-button type="success" @click="addComplaint" style="">新增</el-button>
              <el-button type="warning" @click="resetAll" style="">重置</el-button>
              <el-button type="info" @click="exportComplaint" v-if="export_button">导出</el-button>
              <el-button type="info" @click="exportWord" v-if="export_button">导出word</el-button>
            </div>
          </div>
        </div>

        <div>
          <el-table
            border
            v-loading="listLoading"
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'created_at', order: 'descending' }"
            @sort-change="sortChange"
            min-height="200"
            max-height="1000"
          >
            <el-table-column type="selection" width="50" class="el-checkbox__inner" />
            <el-table-column prop="game_name" label="游戏名称" width="100" />
            <el-table-column prop="account" label="账号" width="100" />
            <el-table-column prop="game_role_name" label="角色名" width="100" />
            <el-table-column prop="game_server" label="区服" width="80" />
            <el-table-column prop="total_money" label="总充值" sortable @sort-method="sortChange" width="80" />
            <el-table-column prop="total_money_week" label="近一周充值" sortable @sort-method="sortChange" width="90" />
            <el-table-column prop="total_money_month" label="近一月充值" sortable @sort-method="sortChange" width="90" />
            <el-table-column prop="audit_status" label="状态" width="60" />
            <el-table-column prop="submit_admin_name" label="提交人" width="80" />
            <el-table-column prop="complaint_type" label="投诉类型" width="80" />
            <el-table-column prop="risk_type" label="风险类型" width="80" />
            <el-table-column prop="complaint_level" label="严重程度" width="80" />
            <el-table-column prop="after_service" label="后续沟通" width="80" />
            <el-table-column prop="risk_level" label="风险等级" width="80" />
            <el-table-column prop="is_ding_talk_text" label="通知状态" width="80" />
            <el-table-column prop="upgrade_type" label="是否升级" width="80" />
            <el-table-column prop="complaint_content" label="问题详情" width="150" :show-overflow-tooltip="true" />
            <el-table-column prop="audit_admin" label="审批人" width="100" />
            <el-table-column prop="submit_type" label="内部/外部" width="100" />
            <el-table-column prop="created_at" label="提交时间" sortable @sort-method="sortChange" width="150" />
            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="viewDetails(scope.row)">查看详情</el-button>
                <el-button size="mini" type="warning" icon="el-icon-edit" @click="fixComplaint(scope.row)" v-if="scope.row.update_button">修改</el-button>
                <el-button size="mini" type="info" @click="historyRecord(scope.row)" v-if="logs_button">历史记录</el-button>
                <el-button size="mini" type="warning" @click="approvalComments(scope.row)" v-if="audit_button">审批批注</el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="delleteComplaint(scope.row)" v-if="destroy_button">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getComplaintList" />

          <el-dialog title="删除" width="40%" center :visible.sync="deleteShow">
            <p>确认删除？</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="deleteShow = false">取 消</el-button>
              <el-button type="primary" @click="sureDelete">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="popupTitle" width="60%" center :visible.sync="addshow" :close-on-click-modal="addControl" @close="closeDialog">
            <el-form style="margin-left: 40px">
              <el-form-item label="游戏名称" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.game_id" filterable :disabled="idDisabled">
                    <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="账号" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.account" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="角色名" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.game_role_name" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="区服" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.game_server" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="投诉类型" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.complaint_type" filterable :disabled="idDisabled">
                    <el-option v-for="item in complaintTypeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="风险类型" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.risk_type" filterable :disabled="idDisabled">
                    <el-option v-for="item in riskTypeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="严重程度" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.complaint_level" filterable :disabled="idDisabled">
                    <el-option v-for="item in complaintLevel" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="后续沟通" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.after_service" filterable :disabled="idDisabled">
                    <el-option v-for="item in afterService" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="是否升级" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select v-model="formData.upgrade_type" filterable :disabled="idDisabled">
                    <el-option v-for="item in checkUpgradeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="问题详情" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input type="textarea" v-model="formData.complaint_content" :rows="4" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="安抚详情" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input type="textarea" v-model="formData.comfort_content" :rows="4" :disabled="idDisabled"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="图片" :label-width="formInputWidth" v-if="photoShow1">
                <el-col :span="16">
                  <el-upload
                    :disabled="idDisabled"
                    v-model="formData.images"
                    :action="apiUrl"
                    drag
                    multiple
                    list-type="picture-card"
                    :file-list="getStableImageFileList('images', fixfilse)"
                    :headers="file_headers"
                    :on-preview="handleFixPreview"
                    :on-success="handleFixSuccess"
                    :on-remove="handleFixRemove"
                    :on-change="(file, fileList) => trackImageUpload('images', file, fileList)"
                    :on-error="handleFixError"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogImageFixVisible">
                    <img width="100%" :src="dialogImageFixUrl" alt />
                  </el-dialog>
                </el-col>
              </el-form-item>
              <el-form-item label="图片" :label-width="formInputWidth" v-if="photoShow2">
                <el-col :span="16" class="closeImg">
                  <el-image v-for="item in formData.images" :key="item" :src="item" style="width: 100px; height: 100px; margin-right: 5px" :preview-src-list="formData.images"> </el-image>
                </el-col>
              </el-form-item>

              <el-form-item label="内部/外部" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-select v-model="formData.submit_type" filterable :disabled="idDisabled">
                    <el-option v-for="item in reportOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="通知人" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-select filterable v-model="formData.notice_admin_id" multiple placeholder="请选择" :disabled="idDisabled">
                    <el-option v-for="item in personOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="审批人" :label-width="formInputWidth">
                <el-col :span="8">
                  <el-input v-model="formData.audit_admin" :disabled="approvedShow"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="风险等级" :label-width="formInputWidth" v-if="riskTypeShow">
                <el-col :span="8">
                  <el-select v-model="formData.risk_level" filterable>
                    <el-option v-for="item in riskLevelOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <el-form-item label="" :label-width="formInputWidth" v-if="functionButtonShow">
                <el-col :span="8">
                  <el-button type="success" @click="fallbackSupplement()">回退补充</el-button>
                  <el-button type="warning" @click="approvedPass()">审批通过</el-button>
                </el-col>
              </el-form-item>
            </el-form>
            <el-table v-if="approvalShow" v-loading="listLoading" :data="formData.tableData" style="width: 100%; margin-top: 10px">
              <el-table-column prop="audit_admin_name" label="审批人" />
              <el-table-column prop="rollback_reason" label="补充原因" />
              <el-table-column prop="audit_status" label="状态" />
              <el-table-column prop="audit_at" label="时间" />
            </el-table>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeComplaint" v-if="fixButtonShow">取 消</el-button>
              <el-button type="primary" @click="sureComplaint" v-if="fixButtonShow">确 定</el-button>
              <el-button type="success" @click="sureComplaint" v-if="submitShow">提 交</el-button>
            </div>
          </el-dialog>

          <el-dialog title="通知" width="40%" center :visible.sync="noticeShow" class="billHandle">
            <p>确认对审批人进行钉钉通知吗？通知后，审批人将收到通知并对您提交的投诉进行查看操作。</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeNotice">取 消</el-button>
              <el-button type="primary" @click="sureNotice">确认</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="approvalTitle" width="40%" center :visible.sync="fallbackShow" :close-on-click-modal="addControl">
            <el-form style="margin-left: -40px">
              <el-form-item label="补充原因" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input type="textarea" v-model="supplementaryReasons" :rows="6"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="fallbackShow = false">取 消</el-button>
              <el-button type="primary" @click="sureSupplement">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import '@/assets/css/global.css';
import Pagination from '@/components/pagination/index';
import {
  getSelectApi,
  getComplaintListApi,
  addComplaintApi,
  fixGetComplaintApi,
  fixPutComplaintApi,
  auditComplaintApi,
  deleteComplaintApi,
  getPermissionApi,
  getTalkPersonApi,
  // 导出word
  getExportWord,
} from '@/api/complaint.js';
import table2excel from '@/vendor/table2Excel.js';
import { exportMethod } from '@/utils/utils';
import { complaintColumn } from './config';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';
export default {
  mixins: [imageUploadMixin],
  components: { Pagination },
  name: 'complaint',
  data() {
    return {
      // 导出下载
      ExportWord: BASE_API + '/admin/download_complaint_docx/',
      listQuery: {
        complaint_level: '',
        after_service: '',
        submit_type: '',
        game_id: '',
        account: '',
        complaint_content: '',
        complaint_type: '',
        risk_type: '',
        upgrade_type: '',
        submit_admin: '',
        risk_level: '',
        audit_status: '',
        is_ding_talk: '',
        created_at: [],
        order_field: 0,
        order_type: 0,
        page: 1,
        limit: 10,
      },
      reportOptions: [],
      gameNameOptions: [],
      complaintTypeOptions: [],
      riskTypeOptions: [],
      checkUpgradeOptions: [],
      riskLevelOptions: [],
      multipleSelection: [],
      audit_statusOptions: [],
      personOptions: [],
      noticeStatusOptions: [],
      complaintLevel: [], // 严重程度
      afterService: [], // 后续沟通
      // 添加数据的缓存。
      addData: {},
      addCheck: 0,

      formData: {
        game_id: '',
        account: '',
        game_role_name: '',
        game_server: '',
        complaint_level: '',
        after_service: '',
        complaint_type: '',
        risk_type: '',
        risk_level: '',
        upgrade_type: '',
        complaint_content: '',
        comfort_content: '',
        submit_type: '',
        send_ding_talk: '',
        images: [],
        report: '',
        approved: '',
        notice_admin_id: [],
        tableData: [],
      },
      tableData: [],
      audit_button: '',
      update_button: '',
      destroy_button: '',
      logs_button: '',
      export_button: '',

      operateCheck: '',
      popupTitle: '',
      photoShow1: false,
      photoShow2: false,
      idDisabled: false,
      formInputWidth: '200px',
      addshow: false,
      deleteShow: false,
      fallbackShow: false,
      supplementaryReasons: '',
      functionButtonShow: false,
      fixButtonShow: false,
      approvalShow: false,
      riskTypeShow: false,
      approvedShow: true,
      submitShow: false,
      noticeShow: false,

      // 内外部权限 区分
      complaint: {},

      // 图片展示部分的数据
      apiUrl: BASE_API + 'admin/work_upload_admin',
      fixfilse: [],
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      dialogImageFixVisible: false,
      dialogImageFixUrl: '',

      listLoading: false,
      total: 1,

      editId: '',
      delID: '',
      approvedID: '',
      audit_status: '',
      form: {
        limit: 10,
        page: 1,
        content: '',
        order_field: 1,
        order_type: 1,
      },
      check: '',
      approvalTitle: '',
    };
  },
  computed: {
    addControl() {
      let item = true;
      if (this.popupTitle == '添加') {
        item = false;
      }
      return item;
    },
  },
  mounted() {
    this.getSelect();
    this.getNoticePerson();
    this.getPermission();
  },
  methods: {
    getPermission() {
      getPermissionApi()
        .then((response) => {
          this.complaint = response.data.data;
          if (this.complaint.inner == true) {
            this.listQuery.submit_type = 1;
          } else if (this.complaint.inner == false && this.complaint.outer == true) {
            this.listQuery.submit_type = 2;
          }
          this.getComplaintList();
        })
        .catch((error) => {});
    },
    getNoticePerson() {
      getTalkPersonApi()
        .then((response) => {
          this.personOptions = response.data.data;
        })
        .catch((error) => {});
    },
    getComplaintList() {
      this.listLoading = true;
      getComplaintListApi(this.listQuery)
        .then((response) => {
          this.tableData = response.data.data.data.map((item) => {
            return {
              ...item,
              total_money: Number(item.total_money),
              total_money_week: Number(item.total_money_week),
              total_money_month: Number(item.total_money_month),
            };
          });
          this.total = response.data.data.total;
          this.audit_button = response.data.data.audit_button;
          this.update_button = response.data.data.update_button;
          this.destroy_button = response.data.data.destroy_button;
          this.logs_button = response.data.data.logs_button;
          this.export_button = response.data.data.export_button;
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    sortChange(column) {
      this.listLoading = true;
      switch (column.prop) {
        case 'total_money':
          this.listQuery.order_field = 1;
          break;
        case 'total_money_week':
          this.listQuery.order_field = 2;
          break;
        case 'total_money_month':
          this.listQuery.order_field = 3;
          break;
        case 'created_at':
          this.listQuery.order_field = 0;
          break;
        default:
          break;
      }
      switch (column.order) {
        case 'ascending':
          this.listQuery.order_type = 1;
          break;
        case 'descending':
          this.listQuery.order_type = 0;
          break;
        default:
          break;
      }
      getComplaintListApi(this.listQuery)
        .then((response) => {
          this.tableData = response.data.data.data.map((item) => {
            return {
              ...item,
              total_money: Number(item.total_money),
            };
          });
          this.total = response.data.data.total;
          this.audit_button = response.data.data.audit_button;
          this.update_button = response.data.data.update_button;
          this.destroy_button = response.data.data.destroy_button;
          this.logs_button = response.data.data.logs_button;
          this.export_button = response.data.data.export_button;
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    getSelect() {
      getSelectApi()
        .then((response) => {
          let m = [];
          // 游戏选择下拉框
          this.gameNameOptions = response.data.data.game;
          // 内部/外部报备
          this.reportOptions = [
            { id: 1, name: response.data.data.submit['1'] },
            { id: 2, name: response.data.data.submit['2'] },
          ];
          // 投诉类型
          this.complaintTypeOptions = response.data.data.complaint.map((m, i) => ({ id: i, name: m }));
          // 风险类型
          this.riskTypeOptions = response.data.data.risk_type.map((m, i) => ({ id: i, name: m }));
          // 是否升级
          this.checkUpgradeOptions = response.data.data.upgrade_type.map((m, i) => ({ id: i, name: m }));
          // 风险等级
          this.riskLevelOptions = response.data.data.risk_level.map((m, i) => ({ id: i, name: m }));
          // 审批状态
          this.audit_statusOptions = response.data.data.audit_status.map((m, i) => ({ id: i, name: m }));
          // 通知状态
          this.noticeStatusOptions = response.data.data.notice.map((m, i) => ({ id: i, name: m }));
          // 严重程度
          this.complaintLevel = response.data.data.complaint_level.map((m, i) => ({ id: i, name: m }));
          // 后续沟通
          this.afterService = response.data.data.after_service.map((m, i) => ({ id: i, name: m }));
        })
        .catch((error) => {});
    },
    search() {
      this.listQuery.page = 1;
      this.getComplaintList();
    },
    resetAll() {
      this.listQuery.game_id = '';
      this.listQuery.account = '';
      this.listQuery.complaint_content = '';
      this.listQuery.complaint_type = '';
      this.listQuery.risk_type = '';
      this.listQuery.complaint_level = '';
      this.listQuery.after_service = '';
      this.listQuery.upgrade_type = '';
      this.listQuery.submit_admin = '';
      this.listQuery.risk_level = '';
      this.listQuery.is_ding_talk = '';
      this.listQuery.audit_status = '';
      this.listQuery.created_at = [];
      this.listQuery.order_field = 0;
      this.listQuery.order_type = 0;
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      if (this.complaint.inner == true) {
        this.listQuery.submit_type = 1;
      } else if (this.complaint.inner == false && this.complaint.outer == true) {
        this.listQuery.submit_type = 2;
      }
      this.getComplaintList();
    },
    reset() {
      this.formData.game_id = '';
      this.formData.account = '';
      this.formData.game_role_name = '';
      this.formData.game_server = '';
      this.formData.complaint_type = '';
      this.formData.risk_type = '';
      this.formData.complaint_level = '';
      this.formData.after_service = '';
      this.formData.upgrade_type = '';
      this.formData.comfort_content = '';
      this.formData.complaint_content = '';
      this.formData.submit_type = '';
      this.formData.notice_admin_id = [];
      this.formData.images = [];
      this.fixfilse = [];
      this.formData.report = '';
      this.formData.approved = '';
    },
    // 导出文档
    exportComplaint() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择投诉记录');
        return;
      }
      // 处理图片链接
      this.multipleSelection.forEach((m) => {
        m.images = m.images.map((n) => n.url);
      });
      table2excel(complaintColumn, this.multipleSelection, '投诉记录');
    },
    // 导出word
    exportWord() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择投诉记录');
        return;
      }
      getExportWord({ id: this.multipleSelection[0].id })
        .then((res) => {
          const link = document.createElement('a');
          let blob = new Blob([res.data], { type: 'application/msword' });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          link.download = '投诉记录'; //下载的文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.$message.error({
            title: '错误',
            desc: '网络连接错误',
          });
          console.log(error);
        });
    },
    addComplaint() {
      this.resetImageUploadScope('images');
      this.popupTitle = '添加';
      this.reset();
      if (this.addCheck == 1) {
        this.formData = JSON.parse(JSON.stringify(this.addData));
        this.fixfilse = this.formData.images;
      }
      this.operateCheck = 1;
      this.riskTypeShow = false;
      this.approvalShow = false;
      this.photoShow1 = true;
      this.photoShow2 = false;
      this.idDisabled = false;
      this.functionButtonShow = false;
      this.fixButtonShow = true;
      this.submitShow = false;
      this.addshow = true;
    },
    sureComplaint() {
      this.noticeShow = true;
    },
    removeComplaint() {
      this.addshow = false;
    },
    removeNotice() {
      this.formData.send_ding_talk = 2;
      this.dataDealWith();
      this.noticeShow = false;
    },
    sureNotice() {
      this.formData.send_ding_talk = 1;
      this.dataDealWith();
      this.noticeShow = false;
    },
    dataDealWith() {
      if (!this.guardImageUploads(['images'])) return;
      if (this.operateCheck == 1) {
        let data = {};
        data.account = this.formData.account;
        data.game_id = this.formData.game_id;
        data.game_role_name = this.formData.game_role_name;
        data.game_server = this.formData.game_server;
        data.complaint_type = this.formData.complaint_type;
        data.risk_type = this.formData.risk_type;
        data.complaint_level = this.formData.complaint_level;
        data.after_service = this.formData.after_service;
        data.upgrade_type = this.formData.upgrade_type;
        data.complaint_content = this.formData.complaint_content;
        data.comfort_content = this.formData.comfort_content;
        data.notice_admin_id = this.formData.notice_admin_id;
        data.send_ding_talk = this.formData.send_ding_talk;
        data.submit_type = this.formData.submit_type;
        let images = [];
        if (this.formData.images != '') {
          for (let item of this.formData.images) {
            images.push(item.url);
          }
          data.images = images;
        }
        addComplaintApi(data)
          .then((response) => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.addCheck = 2;
              this.addshow = false;
              if (this.complaint.inner == true) {
                this.listQuery.submit_type = 1;
              } else if (this.complaint.inner == false && this.complaint.outer == true) {
                this.listQuery.submit_type = 2;
              }
              this.getComplaintList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch((error) => {});
      }
      if (this.operateCheck == 0) {
        let data = {};
        let images = [];
        for (let item of this.formData.images) {
          images.push(item.url);
        }
        data.images = images;
        data.id = this.editId;
        data.account = this.formData.account;
        data.game_id = this.formData.game_id;
        data.game_role_name = this.formData.game_role_name;
        data.game_server = this.formData.game_server;
        data.complaint_type = this.formData.complaint_type;
        data.risk_type = this.formData.risk_type;
        data.complaint_level = this.formData.complaint_level;
        data.after_service = this.formData.after_service;
        data.upgrade_type = this.formData.upgrade_type;
        data.complaint_content = this.formData.complaint_content;
        data.comfort_content = this.formData.comfort_content;
        data.notice_admin_id = this.formData.notice_admin_id;
        data.send_ding_talk = this.formData.send_ding_talk;
        data.submit_type = this.formData.submit_type;
        fixPutComplaintApi(data)
          .then((response) => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              if (this.complaint.inner == true) {
                this.listQuery.submit_type = 1;
              } else if (this.complaint.inner == false && this.complaint.outer == true) {
                this.listQuery.submit_type = 2;
              }
              this.addshow = false;
              this.getComplaintList();
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch((error) => {});
      }
    },
    dataViews(n) {
      fixGetComplaintApi(n)
        .then((response) => {
          let item = response.data.data.complaint_info;
          this.formData.game_id = item.game_id;
          this.formData.account = item.account;
          this.formData.game_role_name = item.game_role_name;
          this.formData.game_server = item.game_server;
          this.formData.complaint_type = item.complaint_type;
          this.formData.risk_type = item.risk_type;
          this.formData.complaint_level = item.complaint_level;
          this.formData.after_service = item.after_service;
          this.formData.risk_level = item.risk_level;
          this.formData.upgrade_type = item.upgrade_type;
          this.formData.submit_type = item.submit_type;
          this.formData.complaint_content = item.complaint_content;
          this.formData.comfort_content = item.comfort_content;
          this.formData.images = item.images;
          this.formData.audit_admin = item.audit_admin;
          this.fixfilse = [];
          this.formData.report = '';
          let arr = [];
          for (let obj of item.notice_admin_id) {
            arr.push(Number(obj));
          }
          this.formData.notice_admin_id = arr;
          if (this.popupTitle == '修改') {
            let images = [];
            for (let item of this.formData.images) {
              let array = {};
              array.url = item;
              images.push(array);
            }
            this.formData.images = normalizeImageList(images, 'complaint');
            this.fixfilse = this.formData.images;
          }
          this.formData.tableData = response.data.data.audit_list;
        })
        .catch((error) => {});
    },

    // 表格数据的按钮
    viewDetails(item) {
      let m = {};
      m.id = item.id;
      this.popupTitle = '投诉记录详情';
      this.dataViews(m);
      this.riskTypeShow = false;
      this.approvalShow = true;
      this.photoShow1 = false;
      this.photoShow2 = true;
      this.idDisabled = true;
      this.functionButtonShow = false;
      this.fixButtonShow = false;
      this.submitShow = false;
      this.addshow = true;
    },
    fixComplaint(item) {
      this.resetImageUploadScope('images');
      this.popupTitle = '修改';
      let m = {};
      m.id = item.id;
      this.editId = item.id;
      this.dataViews(m);
      this.operateCheck = 0;
      this.submitShow = true;
      this.riskTypeShow = false;
      this.approvalShow = true;
      this.photoShow1 = true;
      this.photoShow2 = false;
      this.idDisabled = false;
      this.functionButtonShow = false;
      this.fixButtonShow = false;
      this.addshow = true;
    },
    historyRecord(item) {
      let data = {
        id: '',
      };
      data.id = item.id;
      data = JSON.stringify(data);
      this.$router.push({ path: '/dpartmentSmmary-complaint_histoty', query: { data } });
    },
    approvalComments(item) {
      this.formData.riskLevel = '';
      this.popupTitle = '审批批注';
      this.approvedID = item.id;
      let m = {};
      m.id = item.id;
      this.dataViews(m);
      this.approvalShow = true;
      this.submitShow = false;
      this.photoShow1 = false;
      this.photoShow2 = true;
      this.idDisabled = true;
      this.functionButtonShow = true;
      this.fixButtonShow = false;
      this.riskTypeShow = true;
      this.addshow = true;
    },
    delleteComplaint(item) {
      this.delID = item.id;
      this.deleteShow = true;
    },
    sureDelete() {
      let data = {};
      data.id = this.delID;
      deleteComplaintApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            if (this.complaint.inner == true) {
              this.listQuery.submit_type = 1;
            } else if (this.complaint.inner == false && this.complaint.outer == true) {
              this.listQuery.submit_type = 2;
            }
            this.getComplaintList();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
      this.deleteShow = false;
    },

    fallbackSupplement() {
      if (this.formData.risk_level == '') {
        this.$message.error('请先选择风险等级');
        return;
      }
      this.approvalTitle = '回退补充';
      this.audit_status = 2;
      this.supplementaryReasons = '';
      this.fallbackShow = true;
    },
    sureSupplement() {
      let data = {};
      data.id = this.approvedID;
      data.risk_level = this.formData.risk_level;
      data.audit_status = this.audit_status;
      data.rollback_reason = this.supplementaryReasons;
      auditComplaintApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            if (this.complaint.inner == true) {
              this.listQuery.submit_type = 1;
            } else if (this.complaint.inner == false && this.complaint.outer == true) {
              this.listQuery.submit_type = 2;
            }
            this.getComplaintList();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
      this.fallbackShow = false;
      this.addshow = false;
    },
    closeDialog() {
      if (this.popupTitle == '添加' && (this.addCheck == 0 || this.addCheck == 1)) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.popupTitle == '添加' && this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
    approvedPass() {
      if (this.formData.risk_level == '') {
        this.$message.error('请先选择风险等级');
        return;
      }
      this.approvalTitle = '审批通过';
      this.audit_status = 3;
      this.supplementaryReasons = '';
      this.fallbackShow = true;
    },
    // 数据的导出
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (let item of val) {
        let array = [];
        for (let m of item.images) {
          let a = {};
          a.url = m;
          array.push(a);
        }
        item.images = array;
        this.multipleSelection.push(item);
      }
    },
    // 图片相关的三个函数
    handleFixPreview(file) {
      this.dialogImageFixUrl = file.url;
      this.dialogImageFixVisible = true;
    },
    handleFixSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.fixfilse = appendImageInSelectionOrder(this.fixfilse, file, { url: response.data.path, name: response.data.name || file.name });
        this.formData.images = this.fixfilse;
        this.trackImageUpload('images', file, fileList);
        this.$message.success(response.message);
      }
    },
    handleFixRemove(file, fileList) {
      this.fixfilse = removeImageByUploadFile(this.fixfilse, file);
      this.formData.images = this.fixfilse;
      this.removeTrackedImage('images', file, fileList);
    },
    handleFixError(error, file, fileList) {
      if (!this.isCurrentImageUpload('images', file)) return;
      this.trackImageUpload('images', file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
  },
};
</script>

<style>
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
  overflow: hidden;
}
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
</style>
